export default "__VITE_ASSET__w$b__vNR__"